import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'mwe-header-logo-image',
  templateUrl: './header-logo-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderLogoImageComponent {}
